import useTranslation from 'next-translate/useTranslation';

type ProgressBarBlockProps = {
    tasksCount: number;
    completedTasksCount: number;
};

const ProgressBarBlock = ({ tasksCount, completedTasksCount }: ProgressBarBlockProps) => {
    const { t } = useTranslation('commons');

    return (
        <div>
            <p className="mb-2 font-GMedium text-xs text-icoGray-500">
                {t(`modal_first_stats_status.progress.title`)}
            </p>
            <p className="mb-3">{t(`modal_first_stats_status.progress.label`)}</p>
            <div className="h-1.75 w-full overflow-hidden rounded-full bg-icoGray-300">
                <div
                    className="relative h-full bg-icoGreen"
                    style={{
                        width: `${
                            completedTasksCount === 0 ? 0 : (completedTasksCount / tasksCount) * 100
                        }%`
                    }}></div>
            </div>
        </div>
    );
};

export default ProgressBarBlock;
